import { useState, useEffect } from 'react';
import { useAuthenticationContext } from '../../yoello-lib/modules/auth/AuthenticationContext';

export const useVerifyEmail = () => {
    const { currentUser } = useAuthenticationContext()!;
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [isVerifyingEmail, setIsVerifyingEmail] = useState(true);
    const [emailAddress, setEmailAddress] = useState<string>();

    useEffect(() => {
        const authUser = currentUser as auth0.Auth0UserProfile;
        if (authUser) {
            setIsEmailVerified(!!authUser.email_verified);
            setIsVerifyingEmail(false);
            setEmailAddress(authUser.email);
        }
    }, [currentUser]);

    return {
        isEmailVerified,
        isVerifyingEmail,
        emailAddress
    }
}
